import { ActionTree } from "vuex";
import { baseApi } from "@/config/http-common";
import { IUserState } from "@/store/modules/user/state";
import { UserMutations } from "@/store/modules/user/mutations";
import { IRootState } from "@/store";
import { filemanagerApi } from "@/config/http-filemanager";

export enum UserActions {
  FETCH_DATA_PROVIDER = "FETCH_DATA_PROVIDER_USER",
  FETCH_ONE = "FETCH_ONE_USER",
  CREATE = "CREATE_USER",
  UPDATE = "UPDATE_USER",
  DELETE = "DELETE_USER",
  PROFILE = "FETCH_PROFILE",
  PROFILE_UPDATE = "UPDATE_PROFILE",
  PROFILE_IMAGE_UPLOAD = "PROFILE_IMAGE_UPLOAD",
  PROFILE_IMAGE_UPDATE = "PROFILE_IMAGE_UPDATE",
  PROFILE_IMAGE_DOWNLOAD = "PROFILE_IMAGE_DOWNLOAD",
}

export const actions: ActionTree<IUserState, IRootState> = {
  async [UserActions.FETCH_DATA_PROVIDER]({ commit }, params) {
    try {
      const result = await baseApi.get("/users/users/list", {
        params: params,
      });
      commit(UserMutations.SET_LAZY_DATA, result.data.data);
    } catch (error) {
      console.log("user fetch data error: ", error);
    }
  },
  async [UserActions.FETCH_ONE]({ commit }, id) {
    try {
      const result = await baseApi.get(`/users/users/view/${id}`);
      commit(UserMutations.SET_ONE, result.data.data);
    } catch (error) {
      console.log("user fetch one error: ", error);
    }
  },
  async [UserActions.CREATE]({ commit }, data: Document) {
    return new Promise((resolve, reject) => {
      baseApi
        .post("/users/users/create", data)
        .then((data) => {
          commit(UserMutations.SET_ONE, data);
          resolve(true);
        })
        .catch((error) => {
          console.log("user create error: ", error);
          reject(error.response);
        });
    });
  },
  async [UserActions.UPDATE]({ commit }, { id, data }) {
    return new Promise((resolve, reject) => {
      baseApi
        .put(`/users/users/update/${id}`, data)
        .then((data) => {
          commit(UserMutations.SET_ONE, data);
          resolve(true);
        })
        .catch((error) => {
          console.log("user update error: ", error);
          reject(error.response);
        });
    });
  },
  async [UserActions.DELETE](
    { commit },
    payload: string | { id: string; coordinatorId?: string }
  ) {
    const id = typeof payload === "string" ? payload : payload.id;
    const coordinatorId =
      typeof payload === "object" ? payload.coordinatorId : undefined;
    try {
      await baseApi.delete(`/users/users/delete/${id}`, {
        params: coordinatorId != null ? { coordinatorId } : undefined,
      });
      commit(UserMutations.SET_ONE, null);
    } catch (error) {
      console.log("user delete error:", error);
      throw error;
    }
  },
  async [UserActions.PROFILE]({ commit }) {
    try {
      const result = await baseApi.post(`/users/profile/view`);
      commit(UserMutations.SET_PROFILE, result.data.data);
    } catch (error) {
      console.log("user profile error:", error);
    }
  },
  async [UserActions.PROFILE_UPDATE]({ commit }, payload) {
    return new Promise((resolve, reject) => {
      baseApi
        .post(`/users/profile/update-info`, payload)
        .then((result) => {
          commit(UserMutations.SET_PROFILE, result.data.data);
          resolve(true);
        })
        .catch((error) => {
          reject(error.response);
        });
    });
  },
  async [UserActions.PROFILE_IMAGE_UPLOAD]({ commit }, payload) {
    return new Promise((resolve, reject) => {
      filemanagerApi
        .post(`/profile-image-upload`, payload, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error.response);
        });
    });
  },
  async [UserActions.PROFILE_IMAGE_UPDATE]({ commit }, payload) {
    return new Promise((resolve, reject) => {
      baseApi
        .post(`/users/profile/update-image`, payload)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error.response);
        });
    });
  },
  async [UserActions.PROFILE_IMAGE_DOWNLOAD]({ commit }, payload) {
    return new Promise((resolve, reject) => {
      filemanagerApi
        .get(`/get-profile-image-info`, {
          params: payload,
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error.response);
        });
    });
  },
};
